import * as check from "./checkFunctions.js";
import * as mutateDate from "./mutateDate.js";
import * as mutateCell from "./mutateCell.js";
import { monthNames } from "../../utils/trans/index.js";

export default function loadCalendar(
  duration,
  days,
  daysToAvaliable,
  currMonth,
  currYear,
  dateFrom = null,
  setDateSelected = null,
  setCurrentMonth = null,
  initialLoad = false,
  daysSelectedLoading = false,
  extraPercentage = 0
) {
  let today = new Date();
  let currentMonth = currMonth.toString() ? currMonth : today.getMonth();
  let currentYear = currYear ? currYear : today.getFullYear();
  let months = monthNames[window.appLocale];
  let dateSelectedLocal = new Date();
  let buttonPrev = document.getElementById("previousBtn");
  let buttonNext = document.getElementById("nextBtn");
  let monthAndYearLeft = document.getElementById("monthAndYearLeft");
  let monthAndYearRight = document.getElementById("monthAndYearRight");

  buttonPrev.addEventListener("click", () => {
    previous();
  });
  buttonNext.addEventListener("click", () => {
    next();
  });

  mutateCell.clearCalendar();
  displayCalendar(currentMonth, currentYear, dateFrom, initialLoad);

  function next() {
    currentYear = currentMonth === 11 ? currentYear + 1 : currentYear;
    currentMonth = (currentMonth + 1) % 12;
    setCurrentMonth(currentMonth, currentYear);
    mutateCell.clearCalendar();
    //   let dateFrom = new Date(instance.$store.getters.reservation.date.from);
    !check.checkToday(dateFrom) ? (dateSelectedLocal = dateFrom) : "";
    check.checkToday(dateSelectedLocal)
      ? displayCalendar(currentMonth, currentYear)
      : displayCalendar(currentMonth, currentYear, dateSelectedLocal);
  }

  function previous() {
    currentYear = currentMonth === 0 ? currentYear - 1 : currentYear;
    currentMonth = currentMonth === 0 ? 11 : currentMonth - 1;
    setCurrentMonth(currentMonth, currentYear);

    mutateCell.clearCalendar();
    // let dateFrom = new Date(instance.$store.getters.reservation.date.from);
    !check.checkToday(dateFrom) ? (dateSelectedLocal = dateFrom) : "";


    check.checkToday(dateSelectedLocal)
      ? displayCalendar(currentMonth, currentYear)
      : displayCalendar(currentMonth, currentYear, dateSelectedLocal);
  }

  function showLeftMonth(year, month, dateFrom) {
    check.checkPreviousMonth(currentMonth, currentYear);

    monthAndYearLeft.innerHTML = months[month] + " " + year;
    let tblLeft = document.getElementById("calendar-body-1");

    let firstDay = new Date(year, month).getDay() - 1;
    if(firstDay == -1) firstDay += 7;
    let daysInMonth = 32 - new Date(year, month, 32).getDate();

    let left = true;

    dateFrom
      ? drawCells(tblLeft, year, month, firstDay, daysInMonth, left, dateFrom, daysSelectedLoading)
      : drawCells(tblLeft, year, month, firstDay, daysInMonth, left, null, daysSelectedLoading);

    return [...tblLeft.querySelectorAll('.cell:not(.disabled)')].length;
  }

  function showRightMonth(year, month, dateFrom) {
    monthAndYearRight.innerHTML = months[month] + " " + year;
    let tblRight = document.getElementById("calendar-body-2");

    let firstDay = new Date(year, month).getDay() - 1;
    if(firstDay == -1) firstDay += 7;

    let daysInMonth = 32 - new Date(year, month, 32).getDate();

    let left = false;

    dateFrom
      ? drawCells(tblRight, year, month, firstDay, daysInMonth, left, dateFrom, daysSelectedLoading)
      : drawCells(tblRight, year, month, firstDay, daysInMonth, left, null, daysSelectedLoading);
  }

  function drawCells(tbl, year, month, firstDay, daysInMonth, left, dateFrom, daysSelectedLoading) {
    let date = 1;

    //weeks
    for (let i = 0; i < 6; i++) {
      let row = document.createElement("tr");

      //days
      for (let j = 0; j < 7; j++) {
        if (i === 0 && j < firstDay) {
          let cell = document.createElement("td");
          let cellText = document.createTextNode("");
          cell.appendChild(cellText);
          row.appendChild(cell);
          cell = mutateCell.disableCell(cell);

        } else if (date > daysInMonth) {
          break;
        } else {
          let cell = document.createElement("td");
          let cellText = document.createTextNode(date);
          cell.classList.add("cell");

          cell.setAttribute("data-day", date);
          check.checkToday(new Date(year, month, date,12,0,0)) && cell.classList.add('today')
          let checkDate = new Date(year, month, date,12,0,0);
          if (dateFrom) {
            if (
              check.checkInRange(
                dateFrom,
                mutateDate.getDateTo(dateFrom, duration),
                checkDate
              )
            ) {
              if(daysSelectedLoading){
                  const spanLoading = document.createElement('span');
                  spanLoading.classList.add('loading');
                  cell.appendChild(spanLoading);
                }else{
                cell.classList.add("selected");
                check.checkFirst(dateFrom, checkDate) &&
                  cell.classList.add("first");

                check.checkLast(
                  mutateDate.getDateTo(dateFrom, duration),
                  checkDate
                ) && cell.classList.add("last");
              }
            }

          }
          cell.onclick = function(celltext) {
            // mutateCell.clearCalendar();
            setReservationMethod(year, month, cellText.wholeText, cell.dataset.id);
            // scrollToPosition();

            // if (left) {
            //   showLeftMonth(
            //     year,
            //     month,
            //     new Date(year, month, cellText.wholeText)
            //   );
            //   showRightMonth(
            //     mutateDate.nextYear(month, year),
            //     mutateDate.nextMonth(month),
            //     new Date(year, month, cellText.wholeText)
            //   );
            // } else {
            //   showLeftMonth(
            //     mutateDate.previousYear(month, year),
            //     mutateDate.previousMonth(month),
            //     new Date(year, month, cellText.wholeText)
            //   );
            //   showRightMonth(
            //     year,
            //     month,
            //     new Date(year, month, cellText.wholeText)
            //   );
            // }
          };
          check.checkPastDate(
            checkDate,
            mutateDate.addDays(today, daysToAvaliable)
          ) && cell.classList.add("disabled");

          if(dateFrom && check.checkInRange(
                dateFrom,
                mutateDate.getDateTo(dateFrom, duration),
                checkDate
              )){
                check.checkTypeDateAttribute(days, checkDate, cell, daysSelectedLoading, extraPercentage);
              }else{
                check.checkTypeDateAttribute(days, checkDate, cell, false, extraPercentage);
              }
          dateFrom && check.checkTypeDateSelected(days, dateFrom, cell);

          cell.appendChild(cellText);
          row.appendChild(cell);
          date++;
        }
      }

      if (row.children.length) {
        tbl.appendChild(row); // appending each row into calendar body (unless empty)
      }
    }
    requestAnimationFrame(() => {
      tbl.classList.add("fade-in");
    });
  }

  function setReservationMethod(year, month, date, id) {
    const dateFrom = new Date(year, month, date);
    const dateTo = mutateDate.getDateTo(dateFrom, duration);
    const type = check.checkTypeToMutation(days, dateFrom);

    dateSelectedLocal = dateFrom;
    if (dateFrom.getDate() === dateTo.getDate()) {
      setDateSelected(dateFrom, null, type, id);
    } else {
      setDateSelected(dateFrom, dateTo, type, id);
    }
  }

  function scrollToPosition() {
    window.scrollTo({
      top: screen.width > 992 ? 650 : 0,
      left: 0,
      behavior: "smooth"
    });
  }

  function displayCalendar(month, year, dateFrom, initialLoad) {
    const availableDays = showLeftMonth(year, month, dateFrom);
    let nextYear = mutateDate.nextYear(month, year);
    let nextMonth = mutateDate.nextMonth(month);

    // Show next month on initial load if no available days on current month
    if (initialLoad && availableDays === 0) {
      mutateCell.clearCalendar();
      currentYear = nextYear;
      currentMonth = nextMonth;
      showLeftMonth(nextYear, nextMonth, dateFrom);
      nextYear = mutateDate.nextYear(nextMonth, nextYear);
      nextMonth = mutateDate.nextMonth(nextMonth);
    }

    showRightMonth(nextYear, nextMonth, dateFrom);
  }
}
